import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import CompareUploader from '../components/compare/CompareUploader';
import CompareView from '../components/compare/CompareView';

export default function Compare() {
  const { t } = useTranslation();
  const [files, setFiles] = useState(null);

  return (
    <>
      <Helmet>
        <title>{t('tools:compare.title', 'Compare PDFs')} — Scrivar</title>
      </Helmet>
      {!files ? (
        <div className="bg-gray-50 min-h-screen">
          <CompareUploader onReady={setFiles} />
        </div>
      ) : (
        <CompareView
          file1={files.file1}
          file2={files.file2}
          onClose={() => setFiles(null)}
        />
      )}
    </>
  );
}
